/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import axios from 'axios'

import { checkToken } from '../rest/auth/hooks/useToken'

const CamundaAPI = axios.create({
  baseURL: '/camunda/api/v1',
})

CamundaAPI.interceptors.request.use(checkToken)

export { CamundaAPI }
